/**
 * What the kit's dialogs, menus and notices read of focus: the element that has it, and the controls Tab
 * reaches inside an element. Both read the page only when there is one, so a component that calls them while
 * it renders still renders to static markup under `react-dom/server`.
 */

const FOCUSABLE = "button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";

/**
 * The controls inside an element that Tab reaches, in document order.
 *
 * @param root The element.
 * @returns The controls that are shown and not disabled.
 */
export function tabbable(root: HTMLElement): HTMLElement[] {
  return [...root.querySelectorAll<HTMLElement>(FOCUSABLE)].filter((element) => element.tabIndex >= 0 && element.getClientRects().length > 0);
}

/**
 * What has focus in the page, if there is a page: nothing under `react-dom/server`.
 *
 * @returns The focused element, or null.
 */
export function focused(): Element | null {
  return typeof document === "undefined" ? null : document.activeElement;
}
